import { Base } from "../../../../base/components/base"
import { Img } from "../../../../base/components/native/img"
import { ISocialMedia } from "../social-media-prices/smp-item"
import { CheckTd } from "./check-td"
import { LinkTd } from "./link-td"
import { NameTd } from "./name-td"
import { PriceTd } from "./price-td"
import { PriceToCadTd } from "./price-tocad-td"
import { rateTrStyle, rateTrToCadStyle } from "./rate-tr.style"

export const RateTrToCad = (item?: { title: string, icon: string, prices: [ISocialMedia, ISocialMedia] }) => {
    let changedBuy = false
    let changedSell = false

    const base = Base('tr')
    base.cssClass(rateTrToCadStyle)

    if (!item) {
        return base
    }

    const { title, icon, prices: [buy, sell] } = item

    const name = NameTd(title)
    name.style({ textAlign: 'left', width: '110px', display: 'flex', gap: '5px', alignItems: 'center' })
    const flag = Img(icon, { width: 24 })
    name.prepend(flag)
    base.append(name)

    const sellEl = PriceToCadTd(sell.value)
    base.append(sellEl)


    const buyEl = PriceToCadTd(buy.value)
    base.append(buyEl)


    const db = CheckTd(false)
    db.style({ width: '90px', paddingRight: '6px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' })
    db.disable()
    base.append(db)

    // const telegram = CheckTd(false)
    // telegram.disable()
    // base.append(telegram)

    buyEl.on('change', handleChange)
    sellEl.on('change', handleChange)

    function handleChange() {
        changedBuy = buyEl.changed()
        changedSell = sellEl.changed()
        if (changedBuy || changedSell) {
            db.enable()
            db.check()
            // telegram.enable()
        } else {
            db.disable()
            // telegram.disable()
        }
    }

    return Object.assign(base, {
        getValue: () => {
            return [{

                meta: {
                    db: db.getValue(),
                    // telegram: telegram.getValue()
                },
                value: {
                    key: sell.key,
                    title,
                    value: sellEl.getValue().value,
                    change: Math.round(sellEl.getValue().change * 1000) / 1000,
                    details: ''
                },
                changed: changedSell,


            },
            {
                meta: {
                    db: db.getValue(),
                    // telegram: telegram.getValue()
                },
                value: {
                    key: buy.key,
                    title,
                    value: buyEl.getValue().value,
                    change: Math.round(buyEl.getValue().change * 1000) / 1000,
                    details: ''
                },
                changed: changedBuy
            }]
        }
    })
}